<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('huntingWordsGenerator.edit.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('huntingWordsGenerator.edit.title') }}
        </h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-hunting-words-new' }"
        >
          {{ $t('huntingWordsGenerator.edit.button.add') }}
        </router-link>
      </d-col>
    </d-row>
    <hunting-words-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import HuntingWordsPage from '../components/HuntingWordsPage.vue';

export default {
  name: 'puzzle-edit',
  components: {
    HuntingWordsPage,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(['setToggle', 'getHuntingWords']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getHuntingWords(this.$route.params.puzzleId);
    }
  },
};
</script>
